import React from "react";

interface SelectedDatesProps {
    dates: { date: Date; isHalfDay: boolean }[];
    onToggleHalfDay: (date: Date) => void;
}

const SelectedDates: React.FC<SelectedDatesProps> = ({ dates, onToggleHalfDay }) => {
    return (
        <div className="p-4 rdp-months_select_date border-[1px] border-solid border-surface-border bg-white ">
            <h2 className="font-semibold mt-0">
                Selected Dates ({dates.length} {dates.length === 1 ? "day" : "days"})
            </h2>
            <div className="flex flex-wrap w-full gap-[8px] max-h-[358px] overflow-y-auto">
                {dates.map((dateObj) => (
                    <div
                        key={dateObj.date.toISOString()}
                        className="flex justify-between items-center border-[1px] border-solid border-surface-border leaveadd_bg bg-slate-50 dark:bg-slate-700 w-full cursor-pointer hover:bg-gray-100 p-2"
                    >
                        <span>{dateObj.date.toDateString()}</span>
                        <label className="flex items-center gap-2">
                            <input
                                type="checkbox"
                                checked={dateObj.isHalfDay}
                                onChange={() => onToggleHalfDay(dateObj.date)}
                            />
                            Half Day
                        </label>
                    </div>

                ))}
            </div>
        </div>
    );
};

export default SelectedDates;
